import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import ENVIRONMENT from '../../../environments';
import CustomerMainLayout from '../CustomerComponents/CustomerMainLayout';

const getIframeUserContextPayload = () => {
  const keys = [
    'username',
    'company_id',
    'shared_entities',
    'all3d_jwt_token',
    'user_role',
    'is_admin',
    'is_msprovider',
    'managed_company_id',
    'super_admin_username',
    'is_ai_customer',
  ];

  return keys.reduce((acc, key) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

const MigratedEditAiImage = ({ location }) => {
  const iframeRef = useRef(null);
  const migratedPortalBaseUrl = (
    ENVIRONMENT.MIGRATED_PORTAL_URL ||
    process.env.REACT_APP_MIGRATED_PORTAL_URL ||
    'http://localhost:5173'
  ).replace(/\/$/, '');
  const iframeSrc = `${migratedPortalBaseUrl}/edit-ai-image${location?.search || ''}`;

  const targetOrigin = useMemo(() => {
    try {
      return new URL(migratedPortalBaseUrl).origin;
    } catch {
      return '*';
    }
  }, [migratedPortalBaseUrl]);

  const postUserContext = useCallback(() => {
    const iframeWindow = iframeRef.current?.contentWindow;
    if (!iframeWindow) return;

    iframeWindow.postMessage(
      {
        type: 'ALL3D_USER_CONTEXT',
        payload: getIframeUserContextPayload(),
      },
      targetOrigin
    );
  }, [targetOrigin]);

  useEffect(() => {
    const onMessage = (event) => {
      if (targetOrigin !== '*' && event.origin !== targetOrigin) return;
      if (event.source !== iframeRef.current?.contentWindow) return;

      const { type } = event?.data || {};

      if (type === 'ALL3D_USER_CONTEXT_REQUEST') {
        postUserContext();
      }
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [postUserContext, targetOrigin]);

  return (
    <CustomerMainLayout selected="26" remove_global_padding={true}>
      <div style={{ width: '100%', height: '100%' }}>
        <iframe
          ref={iframeRef}
          title="Edit AI Image"
          src={iframeSrc}
          onLoad={postUserContext}
          style={{
            width: '100%',
            height: '100%',
            border: '0',
            display: 'block',
          }}
        />
      </div>
    </CustomerMainLayout>
  );
};

export default MigratedEditAiImage;
